import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { GlobalState } from "@app/store";
import { PathnameUrl } from "@app/constants";
import InfoLayout from "./info-layout";

/* Trang Giới thiệu theo bản thiết kế introduce.ejs: giữ nguyên chữ và cấp tiêu đề (H1, H2 của thẻ). */

const CARDS: { icon: ReactNode; title: string; text: string }[] = [
  {
    icon: (
      <>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M8 20h8M12 16v4" />
      </>
    ),
    title: "Máy GPU cấu hình cao",
    text: "Làm đồ họa, lập trình, render video và chạy phần mềm nặng như SolidWorks, Blender.",
  },
  {
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    title: "Tự động 24/7",
    text: "Thuê máy hoàn toàn tự động qua website, bất kể ngày đêm.",
  },
  {
    icon: (
      <>
        <rect x="7" y="2" width="10" height="20" rx="2" />
        <path d="M11 18h2" />
      </>
    ),
    title: "Dùng từ mọi thiết bị",
    text: "Điện thoại, laptop hay PC cấu hình thấp có Internet là điều khiển từ xa được.",
  },
  {
    icon: (
      <>
        <path d="M20 12V7H5a2 2 0 0 1 0-4h14v4" />
        <path d="M3 5v14a2 2 0 0 0 2 2h15v-5" />
        <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
      </>
    ),
    title: "Chỉ từ 8.000 đ",
    text: "Không cần bỏ ra hàng chục triệu đồng mua PC để dùng trong thời gian ngắn.",
  },
];

function IntroducePage() {
  const { myInfo } = useSelector(selectMyInfo);
  const loggedIn = !!myInfo._id;

  return (
    <InfoLayout
      current={PathnameUrl.INTRODUCE}
      title="Giới thiệu"
      docTitle="Giới thiệu PC Render: thuê máy tính, server GPU cấu hình cao"
    >
      <section className="hero" aria-labelledby="t">
        <h1 id="t">Giới thiệu</h1>
        <p className="lead">
          <b>PCRender.com</b> là dịch vụ cho thuê máy tính, server có GPU cấu
          hình cao, giúp mọi người thực hiện các công việc như đồ họa, lập
          trình, render video, chạy các phần mềm nặng (SolidWorks, Blender…) một
          cách nhanh chóng, thuận tiện.
        </p>
        <p className="lead">
          Quá trình thuê hoàn toàn tự động qua website, online 24/7. Dù ở bất kỳ
          đâu, bạn cũng có thể thuê máy và điều khiển từ xa qua Remote Desktop.
          Chỉ cần điện thoại, laptop hoặc PC của bạn (không cần cấu hình cao) có
          kết nối Internet là đã có thể kết nối tới các máy tính cấu hình cao
          của chúng tôi.
        </p>
        <p className="lead">
          Giờ đây chỉ với <b>8.000 đ</b>, bạn có thể sử dụng ngay dịch vụ mà
          không cần bỏ ra hàng chục triệu đồng để mua một chiếc PC chỉ dùng
          trong thời gian ngắn. Chúng tôi giúp bạn tiết kiệm nhất có thể!
        </p>
        <p className="hi">
          Chào mừng bạn đến với dịch vụ thuê máy của chúng tôi!
        </p>
        <div className="cta">
          {/* như trang chủ: đã đăng nhập thì vào trang thuê máy, chưa thì sang Đăng ký */}
          <Link
            className="btn btn-primary"
            to={loggedIn ? PathnameUrl.GPU_HUB : "/register"}
          >
            Thuê máy ngay
          </Link>
          <Link className="btn btn-ghost" to={PathnameUrl.CONTACT}>
            Liên hệ với chúng tôi
          </Link>
        </div>
      </section>

      <div className="grid">
        {CARDS.map(({ icon, title, text }) => (
          <div key={title} className="card">
            <div className="ib">
              <svg className="i" viewBox="0 0 24 24" aria-hidden="true">
                {icon}
              </svg>
            </div>
            <div>
              <h2>{title}</h2>
              <p>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </InfoLayout>
  );
}

export default IntroducePage;

const selectMyInfo = (state: GlobalState) => state.myInfo;
